import CookiesBanner from './CookiesBanner';
export default CookiesBanner;
